import fieldsSlice from '../reducers/fields.reducer';
import { IField  } from '../../Types/Field';

export interface IFieldsState {
  fields: IField[],
  loading: boolean,
  saving: boolean,
  error: string | null,
}

export const fieldsActions = fieldsSlice.actions;
